import React from 'react';
import Banner from '../Banner/Banner/Banner';
import Aqbm from '../Aqbm/Aqbm';
import Schools from '../Schools/Schools';
import AboutUs from '../AboutUs/AboutUs';
import ScrollUp from 'Components/ScrollUp/ScrollUp';
import Testimonials from '../Testimonials/Testimonials';
import ContactUs from '../ContactUs/ContactUs';
import QuickContact from '../QuickContact/QuickContact';

const Home = () => {
    return (
        <div>
            <Banner/>
            <Aqbm/>
            {/*<Schools/>*/}
            <AboutUs/>
            {/*<Testimonials/>*/}
            {/* <ContactUs/> */}
            {/*<QuickContact/>*/}
            <ScrollUp/>
        </div>
    );
};

export default Home;